import { Box, Link, List, ListItem, Typography } from '@mui/material';
import { FC } from 'react';

export const Step2Shopify: FC = () => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				// alignItems: 'center',
				// justifyContent: 'center',
				mt: '20px',
				gap: '40px',
			}}
		>
			<Box
				sx={{
					display: 'flex',
					backgroundColor: '#0092de24',
					borderRadius: '12px',
					p: '20px',
					// mt: '20px',
					width: 'calc(100%)',
				}}
			>
				<Typography
					sx={{
						fontSize: '3rem',
						color: '#016193',
						fontFamily: 'monospace',
						mr: 2,
						mt: -1,
						mb: -2,
						fontWeight: 'bold',
						textTransform: 'lowercase',
					}}
				>
					i
				</Typography>
				<Box>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193', p: '0 0 8px 0' }}
					>
						The store can&apos;t be connected directly from the Dashboard.{' '}
					</Typography>
					<Typography
						component="p"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						To connect your Shopify store:
					</Typography>
					<Typography
						component="div"
						sx={{ fontSize: '1rem', fontStyle: 'italic', color: '#016193' }}
					>
						<List dense>
							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0  8px 0',
								}}
							>
								1. Install the EAS EU and UK compliance application from&nbsp;
								<Link
									href="https://apps.shopify.com/eas-eu-compliance"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									Shopify app store.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								2. Use API key and API secret key from the General settings menu in the EAS
								dashboard to configure the application:&nbsp;
								<Link
									href="https://dashboard.easproject.com/general-settings"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									General Settings.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								3. To ensure your full compliance with EU VAT regulations, we offer complimentary
								assistance with configuring your Shopify store. Feel free to reach out to us via
								chat or write to &nbsp;
								<Link
									href="mailto:support@easproject.com"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									support@easproject.com
								</Link>
								&nbsp;to request assisted installation. Please, be prepared to provide access to the
								store following{' '}
								<Link
									href="https://help.easproject.com/eas-shopify-collaboration-request"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									help center article.
								</Link>
							</ListItem>

							<ListItem
								sx={{
									display: 'inline-block',
									p: '0 0 8px 0',
								}}
							>
								4. If you wish to configure your Shopify store by yourself, please, follow these
								instructions:&nbsp;
								<Link
									href="https://help.easproject.com/eas-for-shopify#shopify-markets-settings"
									target="_blank"
									rel="noreferrer"
									sx={{
										color: '#016193',
										fontSize: '1rem',
										fontWeight: 'bold',
										textDecoration: 'none',
										'&:hover': {
											textDecoration: 'underline',
										},
									}}
								>
									Configuring Shopify store.
								</Link>
							</ListItem>
						</List>
					</Typography>
				</Box>
			</Box>
		</Box>
	);
};
